import { ReservationPaymentBaseDto } from './reservation-payment-base.dto';
export class ReservationPaymentForSettlementDto extends ReservationPaymentBaseDto {
    constructor(initializer) {
        super(initializer);
        this.reservation = initializer.reservation;
    }
}
